module.exports = __webpack_public_path__ + "static/media/use-pootsy-picto.6b49174f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/use-pootsy-picto.png
// module id = 392
// module chunks = 0